<template>
  <v-app>
    <v-content id="EducationServicesTemplate">
      <div class="header">
        <v-container class="pt-4 pb-3">
          <a
            href="http://educationservices.rti.org/index.html"
            class="homeLink"
          >
            <img src="../../assets/es/RTI_CES.svg" />
          </a>
        </v-container>
      </div>
      <v-content class="layoutContent">
        <router-view></router-view>
      </v-content>
      <v-footer height="auto" class="footer">
        <v-container class="py-0">
          <v-layout row wrap>
            <v-flex sm3 xs12 class="leftNav">
              <ul>
                <li>
                  <a href="http://educationservices.rti.org/index.html">Home</a>
                </li>
                <li>
                  <a href="http://educationservices.rti.org/services.html"
                    >Services</a
                  >
                </li>
                <li>
                  <a href="http://educationservices.rti.org/experts.html"
                    >Experts</a
                  >
                </li>
                <li>
                  <a href="https://educationservices.rti.org/events.html"
                    >Events</a
                  >
                </li>
                <li>
                  <a :href="'mailto:' + contactAddress">Contact Us</a>
                </li>
                <li>
                  <a href="https://www.rti.org" target="_blank"
                    >Visit rti.org</a
                  >
                </li>
              </ul>
            </v-flex>
            <v-flex sm5 offset-sm4 xs12 class="infoCol text-xs-right">
              <div class="logoBox">
                <img
                  src="../../assets/es/RTI_CES_W.svg"
                  style="max-height: 45px; max-width: 600px"
                />
              </div>
              <div class="underLogo text-xs-left">
                <p>
                  © {{ new Date().getFullYear() }} RTI International. RTI
                  International is a trade name of Research Triangle Institute.
                  RTI and the RTI logo are U.S. registered trademarks of
                  Research Triangle Institute.
                </p>
                <p>
                  <a href="https://rti.org/privacy-policy" target="_blank"
                    >Privacy Policy</a
                  >
                  |
                  <a href="https://rti.org/terms-use" target="_blank"
                    >Terms of Use</a
                  >
                  |
                  <a href="https://rti.org/accessibility" target="_blank"
                    >Accessibility</a
                  >
                </p>
                <AmazeDevelopmentInfo/>
              </div>
            </v-flex>
            <v-flex sm12 class="bottomRow"> </v-flex>
          </v-layout>
        </v-container>
      </v-footer>
      <amaze-snackbar></amaze-snackbar>
      <amaze-dialog :showDialog="showDialog" ref="dialog">
        <router-view name="dialogContent" />
      </amaze-dialog>
      <cookie-law theme="royal">
        <div slot-scope="props">
          <p class="py-0 my-0 pr-2" style="display: inline-block; width: 90%">
            RTI uses cookies to offer you the best experience online. By
            continuing to use our website, you agree to the use of cookies. If
            you would like to know more about cookies and how to manage them
            please view our
            <a
              href="https://www.rti.org/privacy-policy"
              target="_blank"
              color="black"
              >Privacy Policy</a
            >.
          </p>
          <v-btn
            class="px-0 py-0 ma-0 mt-2"
            style="display: inline-block; vertical-align: top"
            @click="props.accept"
            >I accept</v-btn
          >
        </div>
      </cookie-law>
    </v-content>
  </v-app>
</template>

<style lang="scss">
@import url('https://use.typekit.net/uef4xqj.css');
@import 'src/styles/es/main.scss';
@import 'src/styles/variables.scss';
.footer {
  a {
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }
}

.closeButton {
  background-color: $amaze-yellow;
  border-radius: 0;
  width: 20px;
  min-width: 68px;
}

@media (min-width: 410px) {
  .homeLink {
    img {
      height: 40px;
    }
  }
}
</style>

<script>
import CookieLaw from 'vue-cookie-law'
import AmazeDialog from '@/components/Widgets/AmazeDialog'
import AmazeDevelopmentInfo from "@/components/Widgets/AmazeDevelopmentInfo";
export default {
  data () {
    return {
      showDialog: this.$route.meta.showDialog,
      developmentMode: process.env.VUE_APP_DEVELOPMENT_FLAG.toLowerCase() === 'true',
      apiBase: process.env.VUE_APP_API_BASE.toLowerCase()
    }
  },
  watch: {
    '$route.meta' ({ showDialog }) {
      this.showDialog = showDialog
    }
  },
  computed: {
    contactAddress () {
      return process.env.VUE_APP_CONTACT_ADDRESS
    }
  },
  components: {
    CookieLaw,
    AmazeDialog,
    AmazeDevelopmentInfo
  }
}
</script>
